import Vue from 'vue';
import VueAudio from 'vue-audio-better';

Vue.use(VueAudio);
